export const renderColors: any = {
  red: '#d20243',
  yellow: '#fcd447',
  green: '#00a1a2',
};
